module.exports = __webpack_public_path__ + "static/media/modal_icon.1b6122cc.svg";